import { keyframes } from '@emotion/react';
import Chip from 'components/material-ui/Chip';
import React from 'react';
import tw, { css } from 'twin.macro';

const animationScale = keyframes`
  to {
    transform: scale(1.15);
    background: var(--color-green-1);
    color: var(--color-light);
  }
`;

const cssResized = css`
	${tw`rounded-12 bg-grey-E px-04 py-12`};
	animation: 0.8s forwards ${animationScale};
	cursor: pointer;
`;

export default function ChipsView({ items, itemResized, onChipClick }) {
	return (
		<div className='flex items-center justify-center flex-wrap max-w-550 mx-auto'>
			{items.map(item => (
				<div key={item.id}>
					<Chip
						css={[ tw`mx-07 my-09`, itemResized?.id === item.id ? cssResized : null ]}
						label={item.label}
						Content={item.label}
						onClick={() => onChipClick(item)}
						// onDelete={() => handleRemoveFromSubject(item)}
					/>
				</div>
			))}
		</div>
	);
}
